// @flow 
import * as React from 'react';
import { hasSubmitSucceeded } from 'redux-form';
import cx from 'classname';
import { Button } from '@phg/stilo-toolbox/v2/component';
import connectWithFormName from 'app/hoc/withFormName';
import createButton from 'app/hoc/createButton';
import l from 'app/Translate';
import { Link } from '@phg/stilo-toolbox/v2/component';
import {buildLoginUrl, getUrlParameter, parseUrl} from '../helpers/url';
import ButtonsContainer from './component/ButtonsContainer';
import PreviousStep from './component/PreviousStep';
import BaseSubmitButton from './component/SubmitButton';
import type { ButtonDerivedProps } from 'app/hoc/createButton';

// ======= [Continue] =======
export const ContinueButton = createButton(({ hasErrors, loading, handleNext }: ButtonDerivedProps) => (
    <Button.Main
        id='continueBtn'
        type="submit"
        className={cx((hasErrors || loading) && 'disabled')}
        disabled={hasErrors || loading}
        onClick={handleNext}
    >
        {l('Continue')}
    </Button.Main>
));

// ======= [Submit] =======
export const SubmitButton = createButton(BaseSubmitButton);

// ======= [Previous] =======
export const BackButton = createButton(({ handleBack }: ButtonDerivedProps) => (
    <PreviousStep id="previousBtn" onClick={handleBack} />
));

// ======= [Advance progress on successful submit] =======
type NextOnSuccessProps = {
    handleNext: () => void, 
    success: boolean
};

class NextOnSuccess_ extends React.Component<NextOnSuccessProps> {
    componentDidUpdate() {
        if (this.props.success) {
            this.props.handleNext();
        }
    }
    
    render() {
        return null;
    }
}

const ConnectedNextOnSuccess_ = connectWithFormName(
    (state, { formName }) => ({
        success: hasSubmitSucceeded(formName)(state)
    })
)(NextOnSuccess_);

export const NextOnSuccess = createButton(ConnectedNextOnSuccess_);

export const LoginLink = () => {
    const token = getUrlParameter('prospect_signup_token');
    if (token === '') return '';
    const parsedURL = parseUrl(window.location.pathname);
    const href = buildLoginUrl(parsedURL.locale, parsedURL.network || '');

    return (<Link id='log-in-link' href={href}>{l('Log in with an existing account')}</Link>);
};

// ======= [Buttons set] =======
type ButtonsProps = {
    back?: boolean,
    submit?: boolean,
    login?: boolean
};

export const Buttons = ({ back, submit, login }: ButtonsProps) => (
    <ButtonsContainer>
        {login && <LoginLink/>}
        {back && <BackButton />}
        {submit ? <SubmitButton/> : <ContinueButton/>}
    </ButtonsContainer>
);
export default Buttons;
